// Feature flags (roadmap §4.3 / §8): every Phase 4-5 feature ships behind one and can be
// toggled remotely via the config served by the API. Defaults are what a fresh client uses offline.

export const FLAGS = {
  cloudSaves: true,
  verifiedRuns: true,
  ads: true,
  sharedWorld: true,
  perps: true,
  freeformPosts: true,
  achievements: true,
  quests: true,
  cosmetics: true,
  apartments: true,
  aiPosts: false, // costs money (LLM): off until an operator enables it
  pidgin: true,
  music: true,
  accessibility: true,
} as const;

export type FlagId = keyof typeof FLAGS;
export type Flags = Record<FlagId, boolean>;

let current: Flags = { ...FLAGS };

export function flags(): Flags {
  return current;
}

export function flag(id: FlagId): boolean {
  return current[id];
}

/** Apply remote overrides (unknown keys ignored). */
export function setFlags(over: Partial<Record<string, boolean>>) {
  const next = { ...FLAGS } as Flags;
  for (const k of Object.keys(FLAGS) as FlagId[]) if (typeof over[k] === "boolean") next[k] = over[k]!;
  current = next;
}
